import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import utils from '../../utils/utils';
import DATE_FORMAT from '../../components/constants/dateFormat';

const AdminDeliveryDayMarketplaceRow = ({ deliveryDayMarketplace }) => {
  return (
    <tr>
      <th scope="row">
        <Link to={`/admin/deliveryDayMarketplaces/${deliveryDayMarketplace.id}`} className="link">
          {deliveryDayMarketplace.id}
        </Link>
      </th>
      <td>{deliveryDayMarketplace.marketplaceName}</td>
      <td>
        #{deliveryDayMarketplace.deliveryDayId} -{' '}
        {utils.getFormattedDateFromString(deliveryDayMarketplace.deliveryDate, DATE_FORMAT.display)}
      </td>
      <td>{utils.getFormattedDateFromString(deliveryDayMarketplace.deadline, DATE_FORMAT.displayWithTime)}</td>
      <td>{deliveryDayMarketplace.totalSum}€</td>
      <td>{deliveryDayMarketplace.totalSumLimit ? `${deliveryDayMarketplace.totalSumLimit}€` : '-'}</td>
      <td>
        <Link to={`/admin/deliveryDayMarketplaces/edit/${deliveryDayMarketplace.id}`} className="link">
          Edit
        </Link>
        <br />
      </td>
    </tr>
  );
};

AdminDeliveryDayMarketplaceRow.propTypes = {
  deliveryDayMarketplace: PropTypes.object.isRequired,
};

export default injectIntl(AdminDeliveryDayMarketplaceRow);
